import { Dispatch, SetStateAction } from 'react';

import { ResourceTagCrudPaneEditor } from '@/components/ResourceTagFilter/ResourceTagCrudPaneEditor';
import { Input } from '@/design-system/components/Input';
import { Text } from '@/design-system/components/Text';
import { ResourceTag } from '@/types/schema';

import { useDatasetDetails } from '../hooks/useDatasetDetails';

export function DatasetDetails(props: {
  isEditing: boolean;
  tagsOnResource: ResourceTag[];
  setTagsOnResource: Dispatch<SetStateAction<ResourceTag[]>>;
  size?: 'sm' | 'lg';
}) {
  const { isEditing, tagsOnResource, setTagsOnResource } = props;
  const name = useDatasetDetails((state) => state.name);
  const description = useDatasetDetails((state) => state.description);
  const onNameChange = useDatasetDetails((state) => state.setName);
  const onDescriptionChange = useDatasetDetails(
    (state) => state.setDescription
  );

  return (
    <div className="flex flex-col items-center">
      <div className="w-full">
        <Text variant="sm" className="mb-1">
          Name
        </Text>
        <Input
          placeholder="Type name..."
          onChange={(e) => onNameChange(e)}
          value={name}
          required
        />
      </div>
      <div className="mt-2 w-full">
        <Text variant="sm" className="mb-1">
          Description
        </Text>
        <Input
          placeholder="Type description..."
          value={description}
          onChange={(e) => onDescriptionChange(e)}
        />
      </div>
      {!isEditing && (
        <div className="mt-2 w-full">
          <ResourceTagCrudPaneEditor
            tagsOnResource={tagsOnResource}
            setTagsOnResource={setTagsOnResource}
          />
        </div>
      )}
    </div>
  );
}
